<div class="empty-container">
	<img src="img/skin/next.svg"/>
	<p class="text-primary text-center">
		Arrive très bientôt.
	</p>
</div>